import { render, staticRenderFns } from "./ItemsIncomeReport.vue?vue&type=template&id=7225f910"
import script from "./ItemsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ItemsIncomeReport.vue?vue&type=script&lang=js"
import style0 from "./ItemsIncomeReport.vue?vue&type=style&index=0&id=7225f910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports